import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import SplitCalendarHeader from "./common/split-calendar-header";

let theme = createTheme({
  palette: {
    text: {
      secondary: "#505050", // Global secondary text color
    },
  },
  typography: {
    // Poppins font family with system fallbacks
    fontFamily: `'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
    
    // Define all typography variants
    h1: {
      fontSize: "32px",
      fontWeight: 700,
      lineHeight: 1.3,
      '@media (max-width:900px)': {
        fontSize: "28px",
      },
      '@media (max-width:600px)': {
        fontSize: "24px",
      },
    },
    h2: {
      fontSize: "28px",
      fontWeight: 700,
      lineHeight: 1.3,
      '@media (max-width:900px)': {
        fontSize: "24px",
      },
      '@media (max-width:600px)': {
        fontSize: "22px",
      },
    },
    h3: {
      fontSize: "42px",
      fontWeight: 700,
      lineHeight: 1.2,
      '@media (max-width:900px)': {
        fontSize: "36px",
      },
      '@media (max-width:600px)': {
        fontSize: "32px",
      },
    },
    h4: {
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: 1.4,
      '@media (max-width:900px)': {
        fontSize: "22px",
      },
      '@media (max-width:600px)': {
        fontSize: "20px",
      },
    },
    h5: {
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: "18px",
      fontWeight: 700,
      lineHeight: 1.5,
    },
    
    // Body text variants
    body1: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: 1.6,
    },
    
    // Custom variants for your dashboard
    bodyLarge: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: 1.5,
    },
    bodySmall: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: 1.5,
    },
    
    // Button text
    button: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: 1.5,
      textTransform: "none",
    },
    
    // Caption text
    caption: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: 1.4,
      color: "#505050",
    },
    
    // Overline (for labels)
    overline: {
      fontSize: "11px",
      fontWeight: 500,
      lineHeight: 1.4,
      letterSpacing: "0.5px",
      textTransform: "uppercase",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1920,
    },
  },
});

theme = responsiveFontSizes(theme);

theme = createTheme(theme, {
  components: {
    MuiDatePicker: {
      defaultProps: {
        slots: { calendarHeader: SplitCalendarHeader },
        // MUI defaults to ["year", "day"], which hides the header's Month button
        views: ["year", "month", "day"],
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          zIndex: 1201,
          [theme.breakpoints.down("sm")]: {
            height: "56px",
          },
          [theme.breakpoints.up("sm")]: {
            height: "64px",
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          [theme.breakpoints.down("sm")]: {
            maxHeight: "400px",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          [theme.breakpoints.down("sm")]: {
            "&.MuiTableCell-head": {
              fontSize: 12,
            },
            fontSize: 12,
          },
        },
      },
    },
  },
});

export default theme;